import React, { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";
import Main from "./main/Main"
import Aos from "aos";
import "aos/dist/aos.css";
import Header from "./header/Header";
import Footer from "./Footer/Footer"



const HeaderLoginOptions = lazy(() => import("../components/LandingComponents/HeaderLoginOptions/HeaderLoginOptions"));
const HeaderRegisterOptions = lazy(() => import("../components/LandingComponents/HeaderRegisterOptions/HeaderRegisterOptions"));


const Landing = () => {

    useEffect(() => {
        const originalStyles = {
            fontSize: document.documentElement.style.fontSize,

        };

        document.documentElement.style.fontSize = "62.5%";

        return () => {
            document.documentElement.style.fontSize = originalStyles.fontSize;
        };
    }, []);



    // useEffect(() => {
    //     Aos.init({ once: true, duration: 1000 });
    // }, []);

    const [isRegisterOpen, setIsRegisterOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [activeHash, setActiveHash] = useState(window.location.hash || "#home");

    // ✅ Use `useCallback` to avoid re-creating functions unnecessarily
    const openRegister = useCallback(() => setIsRegisterOpen(true), []);
    const closeRegister = useCallback(() => setIsRegisterOpen(false), []);

    const openLogin = useCallback(() => {
        setIsHovered(false);
        setIsLoginOpen(true);
    }, []);

    const closeLogin = useCallback(() => setIsLoginOpen(false), []);

    // ✅ Optimize Hash Change Listener

    useEffect(() => {
        const handleHashChange = () => setActiveHash(window.location.hash);
        window.addEventListener("hashchange", handleHashChange);
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    return (
        <>

            <Header
                activeHash={activeHash}
                openLogin={openLogin}
                openRegister={openRegister}
                isHovered={isHovered}
                setIsHovered={setIsHovered}
            />


            <Main openRegister={openRegister} />
            <Footer />


            <Suspense
                fallback={<div>Loading...</div>}
            >
                {isLoginOpen && <HeaderLoginOptions isLoginOpen={isLoginOpen} closeLogin={closeLogin} />}
                {isRegisterOpen && <HeaderRegisterOptions isRegisterOpen={isRegisterOpen} closeRegister={closeRegister} />}
            </Suspense>
        </>
    );
};

export default Landing;
